import { render, staticRenderFns } from "./WalletPane.vue?vue&type=template&id=65518b94&scoped=true"
import script from "./WalletPane.vue?vue&type=script&lang=js"
export * from "./WalletPane.vue?vue&type=script&lang=js"
import style0 from "./WalletPane.vue?vue&type=style&index=0&id=65518b94&prod&lang=sass&scoped=true"
import style1 from "./WalletPane.vue?vue&type=style&index=1&id=65518b94&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65518b94",
  null
  
)

export default component.exports